module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cgu":{"updatedTime":"Last update on"}}}')
  delete Component.options._Ctor
}
